import { createSlice } from "@reduxjs/toolkit";
import { QuantityUnitResponseDto } from "../../shared/dtos/quantityUnit/QuantityUnitResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const quantityUnitSlice = createSlice({
  name: "quantityUnit",
  initialState: getInitialCrudState<QuantityUnitResponseDto>(),
  reducers: {
    ...generateCrudReducers<QuantityUnitResponseDto>(),
  },
});

export const quantityUnitActions = quantityUnitSlice.actions;
export default quantityUnitSlice.reducer;
